'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Exclamation = function (_React$Component) {
    _inherits(Exclamation, _React$Component);

    function Exclamation() {
        _classCallCheck(this, Exclamation);

        return _possibleConstructorReturn(this, (Exclamation.__proto__ || Object.getPrototypeOf(Exclamation)).apply(this, arguments));
    }

    _createClass(Exclamation, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M9.597 0l0.8 25.2h4.8l0.8-25.2zM12.797 27.2c-1.325 0-2.4 1.075-2.4 2.4s1.075 2.4 2.4 2.4c1.325 0 2.4-1.075 2.4-2.4s-1.075-2.4-2.4-2.4z' })
            );
        }
    }]);

    return Exclamation;
}(_react2.default.Component);

Exclamation.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Exclamation;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/exclamation.js
// module id = 1097
// module chunks = 0